module.exports = __webpack_public_path__ + "img/dog-winking.5dd26bdd.gif";